import PropTypes from 'prop-types'

import defaultProps from '@/components/Form/defaultProps'
import Field from '@/components/Form/Field'
import propTypes from '@/components/Form/propTypes'
import cn from '@/utilities/cn'

import DateTimeGroup from './DateTimeGroup'

import './index.scss'

const DateTimePicker = ({ className, onChange, ...props }: any) => (
  <Field
    {...props}
    className={cn('form__datepicker', className)}
    // @ts-expect-error
    render={({ ...field }) => <DateTimeGroup {...field} onChange={onChange} />}
  />
)

DateTimePicker.displayName = 'DateTimePicker'

DateTimePicker.propTypes = {
  ...propTypes,
  /**
   * optional callback for each date visible in a picker to determine if it's a valid selection or not. function takes
   * arguments of `currentDate`, which is the date to validate, and `selectedDate`, the already selected value in the
   * picker, and must return a boolean
   */
  isValid: PropTypes.func,
  /**
   * Whether the time field should be shown by default
   */
  includeTime: PropTypes.bool,
  showTime: PropTypes.bool,
  defaultValue: PropTypes.string,
  defaultTime: PropTypes.shape({
    hours: PropTypes.number,
    minutes: PropTypes.number,
    seconds: PropTypes.number,
    milliseconds: PropTypes.number
  })
}

DateTimePicker.defaultProps = {
  ...defaultProps,
  isValid: () => true,
  includeTime: false
}

export default DateTimePicker
